import React from "react";
import { Flex, Text, Box } from "theme-ui";

class HoverBox extends React.PureComponent {

    render() {
        const { className, hoverText, numPassed, numFailed, source } = this.props;
        
        return (
            <Box className={`hover-box ${className}`}>
                <Flex className={`${source === "dataSource" ? "datasource" : "hover-tool-tip"}`}>
                    <Text sx={{
                        fontWeight: 600, color:"#262626",
                    }}>
                        {source === "dataSource" ? <span>Tests Passed :{numPassed}<br />Tests Failed :{numFailed}</span> : hoverText || ""}

                    </Text>
                </Flex>
            </Box>
        );
    }
}

export default HoverBox;
